import trackEvent from "@analytics/utils/trackEvent";

const IPSearchAnalyticsService = {
  fetchAIInsights: () => trackEvent("Fetched AI Insights", {}),
  trackAIInsightCopied: () => trackEvent("AI Insights Copied", {}),
  trackCompaniesDownloaded: (rowCount: number) =>
    trackEvent("File Downloaded", {
      file_name: "companyList",
      row_count: rowCount,
    }),
  trackIpSearchInitiated: (query: string) => trackEvent("Smart Search Initiated", { query }),
  trackSummaryNegativelyRated: (insight: string) => trackEvent("Summary Negatively Rated", { insight }),
  trackSummaryPositivelyRated: () => trackEvent("Summary Positively Rated"),
} as const;

export default IPSearchAnalyticsService;
